

export module FooTable {

	export async function initAllAsync(container:JQuery): Promise<void> {

		var count = container.find(".table-footable").length;

		return new Promise<void>((resolve, reject) => {

			if (count == 0) {
				resolve();
				return;
			}

			$.each(container.find(".table-footable"), (i, e) => {
				var ft = new FooTable($(e));
				ft.init(function () {
					count -= 1;
					if (count == 0)
						resolve();
				});
			});

			//container.find(".table-footable").each(function () {
			//	var ft = new FooTable($(this));
			//	ft.init(function () {
			//		count -= 1;
			//		if (count == 0)
			//			resolve();
			//	});
			//});

		});

	}

	export class FooTable {

		private element: JQuery;

		constructor(elem: JQuery) {
			this.element = elem;
		}

		public init(callback: ()=>void): void {

			var self = this;
			var options = new FooTableOptions();

			this.element.footable(options, function (ft) {
				self.element.data("self", ft);
				self.element.addClass("fadeIn").addClass("in");
				setTimeout(function () { self.element.removeClass("animated"); callback(); }, 10);
			})
				.on("expand.ft.row", function (e, ft, row) {
					$(row.$el).addClass("expanded");
					$(row.$details.find("table")).removeClass("animated").addClass("in").addClass("table-footable-inner").addClass("table-bordered");
				})

				.on("collapse.ft.row", function (e, ft, row) {
					$(row.$el).removeClass("expanded");
				});
		}

	}



	export class FooTableOptions {
		//breakpoints = {
		//	phone: 480,
		//	tablet: 1024
		//};
		empty: String = "No results.";
		showToggle: Boolean = true;
		toggleSelector: String = ".footable-toggle";
		toggleColumn: String = "first";
		expandFirst: Boolean = false;
		expandAll: Boolean = false;

		onCollapseRow: (e: Event, table: Object, row: Object) => JQuery;
		onExpandRow: (e: Event, table: Object, row: Object) => JQuery;
	}

}

